import { useMutation, useQueryClient } from "@tanstack/react-query"
import axios from "axios"
import { getWhatsappOpeningMessagesQueryKey } from "modules/campaigns/lib/templates/openingMessages/whatsappOpeningMessagesQuery"
import { useTranslation } from "react-i18next"
import { GetWhatsappOpeningMessageSchema, UpsertWhatsappOpeningMessageSchema } from "schema"
import { toast } from "sonner"
import { z } from "zod"

export const useUpdateWhatsappOpeningMessageMutation = () => {
  const { t } = useTranslation()
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: async ({
      id,
      ...props
    }: z.infer<typeof UpsertWhatsappOpeningMessageSchema> &
      z.input<typeof GetWhatsappOpeningMessageSchema>) => {
      const { data } = await axios.post(`/integrations/whatsapp/opening-messages/${id}`, props)
      return data.data
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: getWhatsappOpeningMessagesQueryKey() })
      toast.success(t("campaigns.templates.openingMessages.updatedSuccess"))
    },
  })
}
